<pv-toolbar class="double" [title]="title$ | async | translate">
	<a class="right-actions fa fa-cog" data-test="settings-toggle" [routerLink]="['/settings']"></a>
	@if (sideMenu.length > 1) {
		<a
			class="left-actions fa fa-bars"
			data-test="menu-toggle"
			[class.notify]="hasNotifications()"
			(click)="showSideNav($event)"
		></a>
	}
</pv-toolbar>

<side-nav position="left" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
	<side-nav-header [title]="'home.menu' | translate" />
	<side-nav-content data-test="home-tab-nav-bar">
		@for (item of sideMenu; track item) {
			<a
				routerLinkActive="active"
				[attr.data-test]="'home-tab-nav-item-' + item.route.path[1]"
				[routerLink]="item.route.path"
				[routerLinkActiveOptions]="{ exact: item.route.exact }"
			>
				<i [class]="'fa-fw ' + item.icon"></i>
				<span class="menu-label">{{ item.text | translate }}</span>
				@if (item.notificationCount?.(); as amount) {
					<div class="notifications-indicator">
						@if (amount < 100) {
							<span data-test="alert-amount">{{ amount }}</span>
						} @else {
							<span class="fa fa-exclamation"></span>
						}
					</div>
				}
			</a>
		}
	</side-nav-content>
</side-nav>

@if ((timeout$ | async) === "disconnect" || (timeout$ | async) === "timeout") {
	<div class="timeout">
		<empty-state
			icon="fa fa-unlink"
			message="{{ ((timeout$ | async) === 'timeout' ? 'general.timeout' : 'general.no_connection') | translate }}"
		/>

		<button (click)="retry()">{{ "general.retry" | translate }}</button>
	</div>
} @else {
	<div class="content">
		<loading-indicator [message]="message$ | async" [running]="loading$ | async" />
		<router-outlet />
	</div>
}
